/* eslint-disable react/no-did-update-set-state */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import _ from 'lodash';


/*
 *  this component turned out pretty bad, we should replace it for something standard
 */
export default class AnimateContentDimensionChange extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    _.defer(this.measureHeight);
  }

  componentDidUpdate(prevProps) {
    const {path} = this.props;
    if (path !== prevProps.path) {
      _.defer(this.measureHeight);
    }
  }

  measureHeight = () => {
    let height = this.refs.innerEl.clientHeight;
    const computedStyle = window.getComputedStyle(this.refs.root);
    height += parseInt(computedStyle['padding-top'], 10);
    height += parseInt(computedStyle['padding-bottom'], 10);
    if (height !== this.state.height) {
      this.setState({height});
    }
  };

  render() {
    const {height} = this.state;
    const {path, style: {flexGrow, transition, margin, marginLeft, marginRight, marginTop, marginBottom, backgroundColor, padding, position, left, ...style}, ...props} = this.props;
    return (
      <div
        ref="root"
        style={{
          height,
          overflow: 'hidden',
          transition,
          margin,
          marginBottom,
          marginLeft,
          marginRight,
          marginTop,
          backgroundColor,
          padding,
          position,
          left,
          flexGrow,
        }}
      >
        <div
          ref="innerEl"
          style={{...style, overflow: 'visible'}}
          {...props}
        />
      </div>
    );
  }
}

AnimateContentDimensionChange.propTypes = {
  style: PropTypes.object.isRequired,
  path: PropTypes.any.isRequired,
};
AnimateContentDimensionChange.defaultProps = {
  style: {},
};